/**
 * Liga a janela de manutenção: a aplicação inteira passa a redirecionar
 * para a página de manutenção e nenhuma rota de feature é carregada.
 *
 * Voltar para `false` (e fazer deploy) restaura a aplicação normalmente.
 */
export const MAINTENANCE_ENABLED = false;
